<template>
    <div
        class="mt-4"
    >
        <div
            v-if="hasLock"
            class="text-green-600 dark:text-green-400"
        >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            You have the lock for this document
        </div>
        <div
            v-if="!hasLock && !!documentLock"
            class="text-red-600 dark:text-red-400"
        >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Document is locked for editing by {{ documentLock.user_name }} at {{ updatedAtFormatted }}

            <Btn
                class="ml-4"
                type="button"
                content="Force takeover"
                @click="$emit('force-takeover')"
            />
        </div>
        <div
            v-if="!hasLock && !documentLock"
            class="text-red-600 dark:text-red-400"
        >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
            </svg>
            Document lock released

            <Btn
                class="ml-4"
                type="button"
                content="Takeover"
                @click="$emit('takeover')"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "LockStatus",
    data() {
        return {

        };
    },
    computed: {
        updatedAtFormatted () {
            return moment(this.documentLock.updated_at).format('YYYY-MM-DD hh:mm:ss');
        },
    },
    props: {
        hasLock: {
            type: Boolean,
            required: false,
            default: true,
        },
        documentLock: {
            type: Object,
            required: false,
        },
    },
};
</script>
